import { AcademyRichText } from '../academy/AcademyRichText';
const internalKeys = new Set(['model_version', 'id', 'toolPath']);
const labels: Record<string, string> = {
  answer_revealed: 'Answer shown',
  selected_formula: 'Selected formula',
  reference_titles: 'References in this view',
  first: 'First measurement',
  second: 'Second measurement',
  prediction_x: 'Predicted x',
  prediction_y: 'Predicted y',
  useWhen: 'When to use it',
};
function label(key: string) {
  return (
    labels[key] ??
    key
      .replace(/_/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (c) => c.toUpperCase())
  );
}
function Value({ value }: { value: unknown }) {
  if (value === null || value === undefined || value === '')
    return <span className="text-slate2">Not selected</span>;
  if (Array.isArray(value))
    return (
      <ul className="space-y-1 pl-3">
        {value.map((item, index) => (
          <li key={index}>
            <Value value={item} />
          </li>
        ))}
      </ul>
    );
  if (typeof value === 'object') return <Fields value={value as Record<string, unknown>} />;
  return (
    <AcademyRichText text={typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value)} />
  );
}
function Fields({ value }: { value: Record<string, unknown> }) {
  return (
    <dl className="space-y-2">
      {Object.entries(value)
        .filter(([key]) => !internalKeys.has(key))
        .map(([key, item]) => (
          <div key={key}>
            <dt className="text-xs font-extrabold text-slate2">{label(key)}</dt>
            <dd className="mt-0.5 break-words text-sm text-ink">
              <Value value={item} />
            </dd>
          </div>
        ))}
    </dl>
  );
}
/** The client builds this bounded snapshot. Rendering plain values never grants it authority. */
export function ToolContextPreview({ snapshot }: { snapshot: string }) {
  try {
    return <Fields value={JSON.parse(snapshot) as Record<string, unknown>} />;
  } catch {
    return <p className="text-sm">Tool context is unavailable. Refresh your preview.</p>;
  }
}
